import React from 'react'
import PropTypes from 'prop-types'

import { MenuLink } from 'components/_new/ui/Menu'


const HeaderSubNavItemSubLink = (props) => {
  const { className, title, to, toOLD, linkId, dataTestId, index, state, setState, _ref, onClick } = props

  return (
    <MenuLink
      className={className}
      id={linkId}
      title={title}
      to={to}
      toOLD={toOLD}
      dataTestId={dataTestId}
      customColor
      index={index}
      state={state}
      setState={setState}
      _ref={_ref(index)}
      onClick={onClick}
    />
  )
}

HeaderSubNavItemSubLink.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
  linkId: PropTypes.string,
  to: PropTypes.string,
  toOLD: PropTypes.string,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
}


export default HeaderSubNavItemSubLink
